import { ChangeDetectionStrategy, Component, HostBinding, Input, inject } from '@angular/core';
import { NgIf, NgFor, NgTemplateOutlet } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { PermissionModule } from '@shared/permission/permission.module';
import { TooltipDirective } from '@shared/directives/tooltip';
import { MENU } from './menu.data';
import { Permission } from 'app/enums';
import { PermissionService } from '@services/permission/permission.service';

@Component({
    selector: 'app-menu',
    templateUrl: './menu.component.html',
    styleUrls: ['./menu.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgIf, NgFor, NgTemplateOutlet, RouterModule, TranslateModule, PermissionModule, TooltipDirective]
})
export class MenuComponent {
    public readonly permissionService = inject(PermissionService);

    @Input() @HostBinding('class.collapsed') public collapsed = true;

    public menu = MENU;
    public permissions = Permission;
}
